/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { parseISO, isValid } from 'date-fns';
import Media from 'react-media';
import {
    object, func, string, bool, shape,
} from 'prop-types';
import * as app from '../../../../../../state/ducks/App';
import {
    validateProductFilterZipcode,
    clearValidatedZipcode,
    resetProductFilterZipcodeValidity,
    setUserSubmittedProductFilterZipcode,
    clearUserSubmittedProductFilterZipcode,
    setProductFilterZipcodeValidity,
    setValidatedZipcode,
    verifyWine,
    resetWineData,
    resetAgeVerifyFlag,
} from '../../../../../../state/ducks/App/App-Actions';
import {
    getValidatedZipcode,
    getUserSubmittedProductFilterZipcode,
    getIsProductFilterZipcodeValid,
    getWineData,
} from '../../../../../../state/ducks/App/App-Selectors';
import ConnectedProductVerification from './ProductVerification';
import ConnectedAddonVerification from './AddonVerification';
import { addToCartDataType } from '../common/types';
import { getDisplayAdditionalCompliance } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const isCanadaZip = (zipcode) => new RegExp(/^[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[- ]{0,1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}/).test(zipcode);
const brandSelectors = app.ducks.brand.selectors;

export class CommonProductAgeZipVerify extends Component {
    constructor(props) {
        super(props);
        const { userSubmittedZip } = this.props;
        this.state = {
            zipField: userSubmittedZip || '',
            zipValid: null,
            inputDayValidated: false,
            inputMonthValidated: false,
            inputYearValidated: false,
            birthDay: '',
            birthMonth: '',
            birthYear: '',
            dayErrorMessage: '',
            monthErrorMessage: '',
            yearErrorMessage: '',
        };
        this.zipFieldRef = React.createRef();
    }

    componentDidMount() {
        const {
            zipValid, resetFilterZipcodeValidity, resetWineDataAll,
        } = this.props;
        if (zipValid === false) {
            resetFilterZipcodeValidity();
        }
        resetWineDataAll();
    }

    getBirthDay = (e) => {
        const value = e.target.value;
        if (Number.isNaN(Number(value)) || Number(value) > 31) {
            return;
        }
        this.setState({ birthDay: value });
    }

    getBirthMonth = (e) => {
        const value = e.target.value;
        if (Number.isNaN(Number(value)) || Number(value) > 12) {
            return;
        }
        this.setState({ birthMonth: value });
    }

    getBirthYear = (e) => {
        const value = e.target.value;
        if (Number.isNaN(Number(value))) {
            return;
        }
        this.setState({ birthYear: value });
    }

    /*
    * @description verifying the age based on day/month/year and default min age value is 21
    */
    handleAgeVerification = () => {
        const {
            birthDay, birthMonth, birthYear, inputYearValidated, inputDayValidated, inputMonthValidated,
        } = this.state;
        const { classes, productSkus } = this.props;
        if (!birthDay || !birthMonth || !birthYear) {
            return {
                class: `${classes.ageInput}`,
            };
        }
        const birthDate = new Date(birthYear, birthMonth, birthDay);
        const cur = new Date();
        const diff = cur - birthDate; // This is the difference in milliseconds
        const presentAge = Math.floor(diff / 31557600000); // Divide by 1000*60*60*24*365.25
        const isMinAge = productSkus?.[0]?.minAge > 0 ? productSkus?.[0]?.minAge : '21';
        const parseDate = parseISO(`${birthYear}-${birthMonth}-${birthDay}`);
        const validDate = isValid(parseDate);
        if (presentAge !== '' && !validDate) {
            return {
                class: `${classes.ageInput} ${classes.dateInvalid} ${classes.ageInputInvalidIcon} error`,
                flag: false,
            };
        }
        if (presentAge > 0 && presentAge <= isMinAge && (!inputDayValidated || !inputMonthValidated || !inputYearValidated)) {
            return {
                class: `${classes.ageInput} ${classes.ageInputInvalid} ${classes.ageInputInvalidIcon} error`,
                flag: false,
            };
        }
        if (presentAge >= isMinAge && presentAge < 100 && (!inputDayValidated || !inputMonthValidated || !inputYearValidated)) {
            return {
                class: `${classes.ageInput} ${classes.ageInputValid} ${classes.ageInputTextValid} success`,
                flag: true,
            };
        }
        return {
            class: `${classes.ageInput}`,
        };
    };

    validateFields = (e) => {
        const id = e.target.id;
        const value = e.target.value;
        const numaricOnly = /^[0-9]+$/;
        const current_year = new Date().getFullYear();
        let dayErrorMessage = '';
        let monthErrorMessage = '';
        let yearErrorMessage = '';
        let { inputDayValidated, inputMonthValidated, inputYearValidated } = this.state;
        if (id === 'day') {
            if (value === '') {
                dayErrorMessage = 'Date is required!';
                inputDayValidated = true;
            } else if (value.length !== 2) {
                dayErrorMessage = 'Date should be two digits!';
                inputDayValidated = true;
            } else if ((value > 31)) {
                dayErrorMessage = 'Date is invalid';
                inputDayValidated = true;
            } else if ((!numaricOnly.test(value))) {
                dayErrorMessage = 'Please enter numeric values only!';
                inputDayValidated = true;
            } else {
                dayErrorMessage = '';
                inputDayValidated = false;
            }
        }
        if (id === 'month') {
            if (value === '') {
                monthErrorMessage = 'Month is required!';
                inputMonthValidated = true;
            } else if (value.length !== 2) {
                monthErrorMessage = 'Month should be two digits!';
                inputMonthValidated = true;
            } else if ((value > 12)) {
                monthErrorMessage = 'Month is invalid';
                inputMonthValidated = true;
            } else if ((!numaricOnly.test(value))) {
                monthErrorMessage = 'Please enter numeric values only!';
                inputMonthValidated = true;
            } else {
                monthErrorMessage = '';
                inputMonthValidated = false;
            }
        }
        if (id === 'year') {
            if (value === '') {
                yearErrorMessage = 'Year is required!';
                inputYearValidated = true;
            } else if (value.length < 4) {
                yearErrorMessage = 'Year should be 4 digits!';
                inputYearValidated = true;
            } else if ((value < 1920) || (value > current_year)) {
                yearErrorMessage = 'Year is invalid!';
                inputYearValidated = true;
            } else if ((!numaricOnly.test(value))) {
                yearErrorMessage = 'Please enter numeric values only!';
                inputYearValidated = true;
            } else {
                monthErrorMessage = '';
                inputYearValidated = false;
            }
        }
        this.setState({
            dayErrorMessage, monthErrorMessage, yearErrorMessage, inputDayValidated, inputMonthValidated, inputYearValidated,
        });
    };

    handleZipChange = (e) => {
        let zipCode = e.target.value;
        const { zipField } = this.state;
        if (isCanadaZip(zipCode)) {
            zipCode = this.convertZipCode(zipCode, zipField);
        }
        this.setState(
            {
                zipField: zipCode,
            },
        );
    };

    /*
    * @description get the availability from API response
    * @param {object} data
    */
    getAvailability = (data) => {
        let availability = false;
        if (!data?.wineAvailability) {
            return false;
        }
        const keys = Object.keys(data.wineAvailability);
        keys.forEach((key) => {
            if (data.wineAvailability[key]?.isProductAvailable) {
                availability = true;
            }
        });
        return availability;
    }

    /*
    * @description This is showing the error/success message after the fields
    */
    displayZipValidCSSCheck = () => {
        const { zipField } = this.state;
        const {
            classes, wineValidation, resetWineDataAll, isAddonAvailable,
        } = this.props;
        if (wineValidation) {
            if (zipField.length < 5) {
                resetWineDataAll();
            }
            if (!isAddonAvailable && zipField.length < 5) {
                resetWineDataAll();
            }
            if (this.getAvailability(wineValidation)) {
                return {
                    classes: `${classes.zipCodeInput} ${classes.zipCodeInputValid} ${classes.zipInputTextValid} zip-code-success`,
                    flag: true,
                };
            }
            return {
                classes: `${classes.zipCodeInput} ${classes.zipCodeInputInvalid} ${classes.zipCodeInputInvalidIcon} zip-code-error`,
                flag: false,
            };
        }
        return {
            classes: `${classes.zipCodeInput}`,
        };
    };

    validateZip = () => {
        // this function determines when to validate a zipcode that the user enters
        const { zipField } = this.state;
        const {
            valZip,
            clearZip,
            zipValid,
            resetZipValidity,
            validatedZip,
            clearFilterZip,
            userSubmittedZip,
        } = this.props;
        if (zipField >= 5) {
            // if user enters five chars check if valid zip
            valZip(zipField);
            this.submitWineForm();
        } else if (zipField < 5 && validatedZip !== '') {
            // if there are fewer than 5 chars and there exists a zip in redux clear it
            // we do this so that if someone enters a zipcode, then deletes it the filtering goes away.
            clearZip();
        }
        if (zipField < 5 && userSubmittedZip !== '') {
            clearFilterZip();
        }
        if (zipField !== 5 && zipValid !== null) {
            // reset the zip is valid flag in redux if zip is not characters.
            resetZipValidity();
        }
    };

    /*
    * @description Submitting the wine form to API.
    */

    submitWineForm = () => {
        const {
            callVerifyWine, addItemAddon, wineValidation, addToCartData, handleMobileAgeVerification,
        } = this.props;
        const { selectedSku, brand } = this.props;
        const brandCode = brand?.id;
        const minAge = selectedSku?.minAge > 0 ? selectedSku?.minAge : '21';
        const skuPartNumber = selectedSku.id;
        const {
            zipField,
            birthYear,
            birthMonth,
            birthDay,
        } = this.state;
        if (skuPartNumber && zipField && birthMonth && birthYear && birthDay) {
            const wineData = {
                birthDay,
                birthMonth,
                birthYear,
                brandCode,
                minAge,
                skuPartNumber,
                zipCodes: [zipField],
            };
            callVerifyWine(wineData, addToCartData, handleMobileAgeVerification);
            if (this.getAvailability(wineValidation)) {
                addItemAddon(selectedSku, 'add');
            }
        }
    }

    /*
    * @description designing the form data for API request
    */
    getWineData = () => {
        const { selectedSku, brand } = this.props;
        const {
            zipField,
            birthDay,
            birthMonth,
            birthYear,
            inputDayValidated,
            inputMonthValidated,
            inputYearValidated,
            zipValid,
        } = this.state;
        const skuPartNumber = selectedSku.id;
        const minAge = selectedSku?.minAge;
        const brandCode = brand?.id;
        const zipCodes = zipField;

        if (skuPartNumber && zipCodes && birthDay && birthMonth && birthYear && zipValid === true && (inputDayValidated || !inputMonthValidated || !inputYearValidated)) {
            const wineData = {
                birthDay,
                birthMonth,
                birthYear,
                brandCode,
                minAge,
                skuPartNumber,
                zipCodes,
            };
            return wineData;
        }
        return null;
    };

    render() {
        const {
            classes,
            oncloseDrawer,
            isAddonAvailable,
            addItemAddon,
            selectedSku,
            mobileAgeVerificationOpen,
            handleMobileAgeVerification,
            modal,
            hasAddons,
            displayAdditionalCompliance,
        } = this.props;
        const {
            zipField,
            dayErrorMessage,
            monthErrorMessage,
            yearErrorMessage,
            birthDay,
            birthMonth,
            birthYear,
        } = this.state;
        if (modal) {
            return (
                <div data-testid="age-verification-modal">
                    <ConnectedAddonVerification
                        isModal
                        hasAddons={hasAddons}
                        classes={classes}
                        zipField={zipField}
                        dayErrorMessage={dayErrorMessage}
                        monthErrorMessage={monthErrorMessage}
                        yearErrorMessage={yearErrorMessage}
                        oncloseDrawer={oncloseDrawer}
                        zipFieldRef={this.zipFieldRef}
                        getBirthDay={this.getBirthDay}
                        getBirthMonth={this.getBirthMonth}
                        getBirthYear={this.getBirthYear}
                        handleAgeVerification={this.handleAgeVerification}
                        validateFields={this.validateFields}
                        handleZipChange={this.handleZipChange}
                        getAvailability={this.getAvailability}
                        displayZipValidCSSCheck={this.displayZipValidCSSCheck}
                        validateZip={this.validateZip}
                        submitWineForm={this.submitWineForm}
                        getWineData={this.getWineData}
                        addItemAddon={addItemAddon}
                        selectedItem={selectedSku}
                        birthDay={birthDay}
                        birthMonth={birthMonth}
                        birthYear={birthYear}
                        mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                        handleMobileAgeVerification={handleMobileAgeVerification}
                        displayAdditionalCompliance={displayAdditionalCompliance}
                    />
                </div>
            );
        }

        return (
            <>
                {isAddonAvailable ? (
                    <div data-testid="desktop-age-verification-addon-drawer">
                        <ConnectedAddonVerification
                            classes={classes}
                            zipField={zipField}
                            dayErrorMessage={dayErrorMessage}
                            monthErrorMessage={monthErrorMessage}
                            yearErrorMessage={yearErrorMessage}
                            oncloseDrawer={oncloseDrawer}
                            zipFieldRef={this.zipFieldRef}
                            getBirthDay={this.getBirthDay}
                            getBirthMonth={this.getBirthMonth}
                            getBirthYear={this.getBirthYear}
                            handleAgeVerification={this.handleAgeVerification}
                            validateFields={this.validateFields}
                            handleZipChange={this.handleZipChange}
                            getAvailability={this.getAvailability}
                            displayZipValidCSSCheck={this.displayZipValidCSSCheck}
                            validateZip={this.validateZip}
                            submitWineForm={this.submitWineForm}
                            getWineData={this.getWineData}
                            addItemAddon={addItemAddon}
                            selectedItem={selectedSku}
                            birthDay={birthDay}
                            birthMonth={birthMonth}
                            birthYear={birthYear}
                        />
                    </div>
                ) : (
                    <Media queries={{ small: '(max-width: 599px)' }}>
                        {(matches) => (matches.small ? (
                            <div data-testid="mobile-age-verification-modal">
                                <ConnectedAddonVerification
                                    isModal
                                    classes={classes}
                                    zipField={zipField}
                                    dayErrorMessage={dayErrorMessage}
                                    monthErrorMessage={monthErrorMessage}
                                    yearErrorMessage={yearErrorMessage}
                                    oncloseDrawer={oncloseDrawer}
                                    zipFieldRef={this.zipFieldRef}
                                    getBirthDay={this.getBirthDay}
                                    getBirthMonth={this.getBirthMonth}
                                    getBirthYear={this.getBirthYear}
                                    handleAgeVerification={this.handleAgeVerification}
                                    validateFields={this.validateFields}
                                    handleZipChange={this.handleZipChange}
                                    getAvailability={this.getAvailability}
                                    displayZipValidCSSCheck={this.displayZipValidCSSCheck}
                                    validateZip={this.validateZip}
                                    submitWineForm={this.submitWineForm}
                                    getWineData={this.getWineData}
                                    addItemAddon={addItemAddon}
                                    selectedItem={selectedSku}
                                    birthDay={birthDay}
                                    birthMonth={birthMonth}
                                    birthYear={birthYear}
                                    mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                                    handleMobileAgeVerification={handleMobileAgeVerification}
                                    displayAdditionalCompliance={displayAdditionalCompliance}
                                />
                            </div>
                        ) : (
                            <div data-testid="desktop-age-verification-card">
                                <ConnectedProductVerification
                                    classes={classes}
                                    zipField={zipField}
                                    dayErrorMessage={dayErrorMessage}
                                    monthErrorMessage={monthErrorMessage}
                                    yearErrorMessage={yearErrorMessage}
                                    zipFieldRef={this.zipFieldRef}
                                    getBirthDay={this.getBirthDay}
                                    getBirthMonth={this.getBirthMonth}
                                    getBirthYear={this.getBirthYear}
                                    handleAgeVerification={this.handleAgeVerification}
                                    validateFields={this.validateFields}
                                    handleZipChange={this.handleZipChange}
                                    getAvailability={this.getAvailability}
                                    displayZipValidCSSCheck={this.displayZipValidCSSCheck}
                                    validateZip={this.validateZip}
                                    submitWineForm={this.submitWineForm}
                                    getWineData={this.getWineData}
                                    birthDay={birthDay}
                                    birthMonth={birthMonth}
                                    birthYear={birthYear}
                                />
                            </div>
                        ))}
                    </Media>

                ) }
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    validatedZip: getValidatedZipcode(state),
    zipValid: getIsProductFilterZipcodeValid(state),
    userSubmittedZip: getUserSubmittedProductFilterZipcode(state),
    brand: brandSelectors.getBrand(state),
    wineValidation: getWineData(state),
    displayAdditionalCompliance: getDisplayAdditionalCompliance(state),
});

const mapDispatchToProps = (dispatch) => ({
    resetZipValidity: bindActionCreators(
        resetProductFilterZipcodeValidity,
        dispatch,
    ),
    setFilterZip: bindActionCreators(
        setUserSubmittedProductFilterZipcode,
        dispatch,
    ),
    setValZip: bindActionCreators(setValidatedZipcode, dispatch),
    callVerifyWine: bindActionCreators(verifyWine, dispatch),
    clearFilterZip: bindActionCreators(clearUserSubmittedProductFilterZipcode, dispatch),
    clearZip: bindActionCreators(clearValidatedZipcode, dispatch),
    setZipcodeValidity: bindActionCreators(setProductFilterZipcodeValidity, dispatch),
    valZip: bindActionCreators(validateProductFilterZipcode, dispatch),
    resetFilterZipcodeValidity: bindActionCreators(resetProductFilterZipcodeValidity, dispatch),
    resetWineDataAll: bindActionCreators(resetWineData, dispatch),
    resetContinueVal: bindActionCreators(resetAgeVerifyFlag, dispatch),

});
CommonProductAgeZipVerify.propTypes = {
    classes: object.isRequired,
    brand: object.isRequired,
    resetZipValidity: func.isRequired,
    oncloseDrawer: func.isRequired,
    validatedZip: string.isRequired,
    zipValid: bool,
    valZip: func.isRequired,
    productSkus: shape({
        minAge: string.isRequired,
    }).isRequired,
    clearZip: func.isRequired,
    userSubmittedZip: string.isRequired,
    clearFilterZip: func.isRequired,
    resetFilterZipcodeValidity: func.isRequired,
    callVerifyWine: func.isRequired,
    addItemAddon: func,
    selectedSku: shape({
        id: string.isRequired,
    }).isRequired,
    resetWineDataAll: func.isRequired,
    wineValidation: shape({
        wineAvailability: object, // object type array
        wineVerify: shape({
            birthDay: 'string',
            birthMonth: 'string',
            birthYear: 'string',
            minAge: 'string',
        }),
    }),
    isAddonAvailable: bool,
    mobileAgeVerificationOpen: bool,
    handleMobileAgeVerification: func,
    addToCartData: addToCartDataType,
    modal: bool,
    hasAddons: bool,
    displayAdditionalCompliance: bool,
};
CommonProductAgeZipVerify.defaultProps = {
    zipValid: null,
    isAddonAvailable: false,
    addItemAddon: () => {},
    wineValidation: null,
    mobileAgeVerificationOpen: false,
    handleMobileAgeVerification: () => {},
    addToCartData: {},
    modal: false,
    hasAddons: false,
    displayAdditionalCompliance: false,
};
export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(CommonProductAgeZipVerify),
);
